












































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import DocReviewDialog from "../Dialogs/DocReviewDialog.vue";
import DocSignDialog from "../Dialogs/DocSignDialog.vue";
import { bus } from "../../main";

@Component({
  components: {
    DocReviewDialog,
    DocSignDialog
  }
})
export default class TirociniReInsDoc extends Vue {
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() soggetto!: string; //entità che visualizza l'elenco documenti

  private convenzione: any;
  private consenso: any;
  private show: boolean;
  private docType: string;

  private loadingConvenzioneReview: boolean;
  private loadingConsensoReview: boolean;

  constructor() {
    super();
    this.convenzione = {};
    this.consenso = {}
    this.show = false;
    this.docType = "";

    this.loadingConvenzioneReview = false;
    this.loadingConsensoReview = false;
  }

  openConvenzione() {
    this.loadingConvenzioneReview = true;
    this.docType = "convenzione";
    bus.$emit("openDocConvenzioneReview", this.convenzione);
  }

  openConsenso() {
    this.loadingConsensoReview = true;
    this.docType = "consenso";
    bus.$emit("openDocConsensoReview", this.consenso);
  }

  loadConvenzione() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType
    };
    data
      .dispatchConvenzioneAttivita(this["$store"], payload)
      .then(result => {
        this.convenzione = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadConsenso(){
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType
    };
    data
      .dispatchConsensoAttivita(this["$store"], payload)
      .then(resp => {
        this.consenso = resp;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    if (this.soggetto === "allievo") {
      this.loadConsenso();
    } else {
      this.loadConvenzione();
      this.loadConsenso();
    }

    bus.$on("loadConvenzione", () => {
      this.loadingConvenzioneReview = false;
      this.loadConvenzione();
    });

    bus.$on("loadProgettoOrientamento", () => {
      this.loadingConsensoReview = false;
      this.loadConsenso();
    });

    bus.$on("closeDocReview", () => {
      this.loadingConvenzioneReview = false;
      this.loadingConsensoReview = false;
    });

    bus.$on("refreshDocs", () =>{
      this.loadConvenzione()
      this.loadConsenso()
    })
  }
}
